const requestUrl = {
	// baseUrl:'http://localhost:666/public/subudian'
	baseUrl:'https://api.subudian.com/subudian'
}

export {
	requestUrl
}
